import React from "react";

const fileTypeIcons = {
  pdf: "/fileType/pdf.svg",
  csv: "/fileType/csv.svg",
};

const FileTypeIcon = ({ type }) => {
  const parts = type ? type.split("/") : [];

  const fileExtension =
    parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";

  const iconSrc = fileTypeIcons[fileExtension] || "/fileType/default.svg";

  return (
    <div>
      <img
        src={iconSrc}
        alt={fileExtension || "unknown file type"}
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default FileTypeIcon;
